import React, { Component } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import './carousel-tag.scss';

export class CarouselTag extends Component {
  onTagClick = e => {
    const { tag, onClick, seeAll } = this.props;
    e.preventDefault();
    return onClick(seeAll ? null : tag);
  };

  render() {
    const { tag, isActive } = this.props;

    return (
      // todo - review PLAT-3859 disabling
      // eslint-disable-next-line jsx-a11y/anchor-is-valid
      <a
        href=""
        className={classNames('carousel-tag font-white', { 'carousel-tag-active': isActive })}
        onClick={this.onTagClick}
      >
        {tag}
      </a>
    );
  }
}

CarouselTag.propTypes = {
  tag: PropTypes.string,
  onClick: PropTypes.func,
  isActive: PropTypes.bool,
  seeAll: PropTypes.bool,
};

CarouselTag.defaultProps = {
  tag: '',
  onClick: null,
  isActive: false,
  seeAll: false,
};
